// Redesign 2026 – čistá logika dopočítávaných čísel (bez DOM). Animaci řeší ./counters.js.
// Testy: tests/redesign/counters-format.test.mjs

// Číslo s mezerami (i nezlomitelnými) jako oddělovačem tisíců a čárkou jako desetinnou.
// Mezera se bere jen tehdy, když po ní jdou přesně tři číslice – jinak by se do čísla spolkla
// i mezera před jednotkou („2 361 000 000 CZK“ → číslo „2 361 000 000 “ a přípona „CZK“).
const NUMBER = /\d+(?:[\s  ]\d{3})*(?:,\d+)?/;
// Dva zápisy schválně: `test()` nad globálním regexem si pamatuje `lastIndex`, takže by jeho
// výsledek závisel na pořadí volání.
const SPACE = /[\s  ]/;
const SPACES = /[\s  ]/g;

export const NBSP = ' ';

/**
 * Rozebere text hodnoty na část před číslem, samotné číslo a část za ním.
 *
 * "513,41 mil. Kč" → { target: 513.41, decimals: 2, grouped: false, prefix: '', suffix: ' mil. Kč' }
 * "až 9 %"         → { target: 9, decimals: 0, grouped: false, prefix: 'až ', suffix: ' %' }
 *
 * @returns {null} když v textu žádné číslo není (např. „Česká republika“)
 */
export function parseValue(text) {
  const match = NUMBER.exec(text);
  if (!match) {
    return null;
  }

  const raw = match[0];
  const [whole, fraction = ''] = raw.split(',');
  const target = Number(whole.replace(SPACES, '') + (fraction ? '.' + fraction : ''));

  if (!Number.isFinite(target)) {
    return null;
  }

  return {
    target,
    decimals: fraction.length,
    // oddělovač tisíců doplňujeme jen tam, kde ho má i původní text
    grouped: SPACE.test(whole),
    prefix: text.slice(0, match.index),
    suffix: text.slice(match.index + raw.length),
  };
}

/**
 * Složí mezihodnotu zpět do textu ve stejném formátu, v jakém je cílové číslo.
 * Tisíce odděluje nezlomitelnou mezerou, desetiny čárkou.
 */
export function formatValue(value, { decimals, grouped, prefix, suffix }) {
  const [whole, fraction] = value.toFixed(decimals).split('.');
  const grouping = grouped ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) : whole;

  return prefix + (fraction ? grouping + ',' + fraction : grouping) + suffix;
}

/** Zpomalení na konci (ease-out cubic) – číslo doběhne plynule, ne skokem. */
export function easeOut(progress) {
  return 1 - (1 - progress) ** 3;
}
